module.exports = __webpack_public_path__ + "img/GAME_THREE.a382c79e.png";